/**
 * Adzuki.MobileApp
 */

(function MobileApp($, Adzuki)
{
	"use strict";

	var mobile_app = {};

	// function _getDeviceOs()
	// {
	// 	if (/android/.test(Adzuki.user_agent)) {
	// 		return 'Android';
	// 	}

	// 	return 'iOS';
	// }

	mobile_app.ajaxFailed = function ajaxFailed()
	{
		if (Adzuki.mobile_login) {
			// if (_getDeviceOs() === 'iOS') {
				window.location.href = 'inapp://ajaxFailure';
			// } else {
			// 	// Handle Android Later
			// }
		}
	};

	mobile_app.triggerUpdate = function triggerUpdate(updates_json)
	{
		// var updates;

		if (Adzuki.mobile_login) {
			// updates = $.parseJSON(updates_json);

			// if (_getDeviceOs() === 'iOS') {
				setTimeout(function timeout() {
					window.location.href = 'inapp://sync';
				}, 500);
			// } else {
			// 	// Handle Android Later
			// }
		}
	};

	Adzuki.MobileApp = mobile_app;
}(jQuery, window.Adzuki || {}));